import { Button, Callout, Classes } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { StyledDialog } from "@/components/pieces/StyledDialog";
import { EvaluationCriterionItem } from "@/types/roleplays";

interface DeleteBehaviorItemDialogProps {
  open: boolean;
  onClose: () => void;
  item: EvaluationCriterionItem;
  onDelete: (itemId: string) => void;
  loading?: boolean;
  errorMessage?: string;
}

export function DeleteBehaviorItemDialog({
  open,
  onClose,
  item,
  onDelete,
  loading = false,
  errorMessage = "",
}: DeleteBehaviorItemDialogProps) {
  const handleDelete = () => {
    if (item) {
      onDelete(item.id);
    }
  };

  return (
    <StyledDialog
      isOpen={open}
      onClose={onClose}
      lazy={true}
      title="Delete Behavior Item"
      width="480px"
    >
      <Box
        py={3}
        px={24}
        css={{ lineHeight: "24px" }}
        className={Classes.DIALOG_BODY}
      >
        <p>Are you sure you want to delete this behavior item?</p>

        {item && (
          <Box
            mt={3}
            mb={3}
            p={3}
            css={{
              backgroundColor: "#F7F7F9",
              borderRadius: "4px",
              border: "1px solid #E1E4E8",
            }}
          >
            <Box fontWeight="500">{item.name}</Box>
          </Box>
        )}

        <p className="text-sm text-gray-600">This action cannot be undone.</p>

        {errorMessage && (
          <Box mt={3}>
            <Callout icon={null} intent="danger">
              {errorMessage}
            </Callout>
          </Box>
        )}

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button intent="danger" onClick={handleDelete} loading={loading}>
              Delete
            </Button>
            <Button onClick={onClose} className="ml-2">
              Cancel
            </Button>
          </div>
        </div>
      </Box>
    </StyledDialog>
  );
}
